

import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


const firebaseConfig = {

  

    apiKey: "AIzaSyA1k2dFvLPhZzxFcPnMFXcK54vHgRoxJ_s",
  
    authDomain: "cnccarrental-b496d.firebaseapp.com",
  
    projectId: "cnccarrental-b496d",
  
    storageBucket: "cnccarrental-b496d.appspot.com",
  
    messagingSenderId: "107111406198",
  
    appId: "1:107111406198:web:c1656cfb992abf2929dd57"

  
  

  
  
  };
  
  
  

  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);
  const storage = getStorage(app);
  
  export { db, storage };